import React from "react";
import "./About.css";

const AboutUs = () => {
  return (
    <div className="about-page" id="about">
      <div className="about-container">
        <h1 className="about-title">About Dhanushdhari Real Estate</h1>
        <p className="about-subtitle">
          Trusted. Transparent. Tailored for you.
        </p>

        {/* Intro Section */}
        <section className="about-section fade-in">
          <div className="about-text">
            <h2>Who We Are</h2>
            <p>
              Dhanushdhari Real Estate is a modern property consulting and
              management firm dedicated to helping individuals and families find
              their dream homes and profitable investments. With years of
              industry experience, our team provides personalized, data-driven
              solutions that simplify the process of buying, selling, and
              leasing real estate.
            </p>
            <p>
              We believe real estate is more than just property — it’s about
              building lasting relationships and communities.
            </p>
          </div>

          <div className="about-image">
            <img
              src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
              alt="Luxury building"
            />
          </div>
        </section>

        {/* Mission Section */}
        <section className="about-section reverse slide-up">
          <div className="about-image">
            <img
              src="https://images.unsplash.com/photo-1560448204-e02f11c3d0e2"
              alt="Team meeting"
            />
          </div>
          <div className="about-text">
            <h2>Our Mission</h2>
            <p>
              Our mission is to redefine the real estate experience through
              innovation, integrity, and service excellence. We strive to create
              value for our clients by understanding their unique goals and
              guiding them every step of the way.
            </p>
            <p>
              Whether you’re buying your first home or expanding your investment
              portfolio, we ensure that your experience with Dhanushdhari Real
              Estate is rewarding and stress-free.
            </p>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section fade-in">
          <h2>Meet Our Experts</h2>
          <p className="team-subtitle">
            A passionate team of professionals dedicated to your success.
          </p>

          <div className="team-grid">
            <div className="team-card">
              <img
                src="https://images.unsplash.com/photo-1603415526960-f7e0328c63b1"
                alt="Team member"
                height="300px"
              />
              <h4>Someone</h4>
              <p>Founder & CEO</p>
            </div>
            <div className="team-card">
              <img
                src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d"
                alt="Team member"
                height="300px"
              />
              <h4>Someone</h4>
              <p>Head of Sales</p>
            </div>
            <div className="team-card">
              <img
                src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e"
                alt="Team member"
                height="300px"
              />
              <h4>Someone</h4>
              <p>Marketing Director</p>
            </div>
          </div>
        </section>
      </div>

      {/* <footer className="about-footer">
        <p>© 2024 Dhanushdhari Real Estate LLP. All rights reserved.</p>
        <div>
          <a href="#">Privacy Policy</a> | <a href="#">Terms of Service</a>
        </div>
      </footer> */}
    </div>
  );
};

export default AboutUs;
